export default __webpack_public_path__ + "static/12_Pig-8a781fa409d22a42ca864c91c99dd9b3.png";